$(document).ready(function(){
    if($('.carousel .slider-wrapper').length) {
        $('.carousel .slider-wrapper').slick({
            draggable: false,
            focusOnSelect: false,
            mobileFirst: true,
            touchMove: false,
            prevArrow: '.carousel-prev-button',
            nextArrow: '.carousel-next-button',
            fade: true,
            dots: true,
            dotsClass: 'nav',
            appendDots: $('.carousel .nav-controls .nav-wrapper'),
        });
    }
});